import Breadcrumbs from "@/components/common/sections/Breadcrumbs";
import BreadcrumbsImage from "@/assets/images/breadcrumbs/application-development.webp";

export default function ApplicationDevelopmentPage() {
	return (
		<>
			<Breadcrumbs
				title="Application Development"
				breadcrumbText="Application Development"
				backgroundImage={BreadcrumbsImage}
			/>
		</>
	);
}